import { HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CookieService } from '@services';

export function mockInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  // Inject the current `AuthService` and use it to get an authentication token:
  const getCookie = inject(CookieService).getCookie;

  if (getCookie('mock_mode')) {
    console.log(`Intercepted Http Request: "${req.method} ${req.url}"`);
    const response = new HttpResponse<unknown>({});
    return of(response);
  } else {
    return next(req);
  }
}
